module.exports = __webpack_public_path__ + "static/img/proximanova-regular-webfont.47428d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximanova-regular-webfont.svg
// module id = u6eI
// module chunks = 1